import axios from 'axios'

// Ensures TypeScript knows REACT_APP_API_BASE_URL exists at runtime.
declare global {
  interface Window {
    _env_: {
      REACT_APP_API_BASE_URL: string
    }
  }
}

// Read API URL from `window._env_`
// it's needed to read url fro env.js file
// because we can't use .env in S3 bucket
export const getApiBaseUrl = () => {
  return window._env_?.REACT_APP_API_BASE_URL || ''
}

const API_BASE_URL = getApiBaseUrl()

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
})

export default axiosInstance
